<div class="load-r-content col d-flex justify-content-end">
  <mat-accordion multi>
    <mat-expansion-panel
      matTooltip="{{ 'REPORT_REQUEST_TOOLTIP' | translate }}"
      matTooltipPosition="above"
      class="mb-2"
      [(expanded)]="PDFRequestPanelExpanded">
      <mat-expansion-panel-header>
        <div>
          <span class="fa-light fa-download"></span>
          {{ "DOWNLOAD_ALERTS" | translate }}&nbsp;&nbsp;
        </div>
      </mat-expansion-panel-header>

      <div class="form-inline">
        <button class="btn btn-outline-primary btn-block" (click)="downloadCsvOrJson('csv')"
          [disabled]="loadingCSV">
          @if (loadingCSV) {
            <span>
              {{'LOADING_CSV'| translate}}...
              <img class="fadeLoader centerLoader logoSmall" style="width: 30px"
                src="assets/img/loading_logo.svg">
              </span>
            } @else {
              CSV
            }

          </button>

          <button
            class="btn btn-outline-primary btn-block"
            [disabled]="loadingPDF && !pdfError"
            (click)="downloadPdf()">
            @if (loadingPDF) {
              <span>
                @if (pdfError) {
                  <span>{{'PDF_RETRY'| translate}}</span>
                } @else {
                  {{'LOADING_PDF'| translate}}...
                  <img class="fadeLoader centerLoader logoSmall" style="width: 30px"
                    src="assets/img/loading_logo.svg">
                  }
                </span>
              } @else {
                @if (pdfError) {
                  <span>{{'PDF_RETRY'| translate}}</span>
                } @else {
                  PDF
                }
              }

            </button>

            @if (selectedTab === 'Alert') {
              <button
                class="btn btn-outline-primary btn-block"
                (click)="downloadCsvOrJson('json')"
                [disabled]="loadingJSON">
                @if (loadingJSON) {
                  <span>
                    {{'LOADING_JSON'| translate}}...
                    <img class="fadeLoader centerLoader logoSmall" style="width: 30px"
                      src="assets/img/loading_logo.svg">
                    </span>
                  } @else {
                    JSON
                  }
                </button>
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
